var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3a3 3 0 00-3 3v12a3 3 0 003 3h18a3 3 0 003-3V6a3 3 0 00-3-3z",
    fill: "#25D366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18l.848-3.082a5.912 5.912 0 01-.798-2.973C6.052 8.668 8.732 6 12.025 6c1.598 0 3.098.62 4.227 1.744A5.898 5.898 0 0118 11.951c-.002 3.278-2.682 5.946-5.975 5.946a6 6 0 01-2.857-.724L6 18zm3.314-1.904c.842.498 1.646.796 2.71.796 2.736 0 4.966-2.216 4.967-4.942.001-2.731-2.218-4.945-4.964-4.946-2.739 0-4.967 2.217-4.968 4.942 0 1.113.327 1.946.877 2.817l-.502 1.824 1.88-.49zm5.72-2.732c-.036-.062-.136-.099-.285-.173-.15-.075-.884-.434-1.02-.484-.137-.049-.237-.074-.337.075-.1.149-.386.483-.473.582-.087.1-.174.112-.323.037-.15-.074-.63-.23-1.2-.737a4.475 4.475 0 01-.831-1.03c-.087-.148-.01-.229.065-.303.067-.066.15-.173.224-.26.076-.086.1-.148.15-.248.05-.098.026-.186-.012-.26-.038-.074-.336-.806-.46-1.103-.122-.29-.245-.25-.336-.255L9.91 9.2c-.1 0-.262.037-.398.186-.137.149-.523.508-.523 1.24 0 .731.535 1.438.61 1.537.074.098 1.052 1.6 2.55 2.243.356.153.634.244.85.313.358.113.684.097.941.059.287-.043.883-.36 1.008-.707s.125-.644.087-.707z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.228ff00b7f39491bfe4acdf9279a8a66.svg";
export { ForwardRef as ReactComponent };